import { AdminLayout } from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
export const AdminMeals = () => {
  const {
    toast
  } = useToast();
  const {
    data: meals,
    isLoading
  } = useQuery({
    queryKey: ['admin-meals'],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from('meals').select(`
          *,
          profiles:chef_id (
            first_name,
            last_name
          )
        `).order('created_at', {
        ascending: false
      });
      if (error) throw error;
      return data;
    }
  });
  const handleStatusToggle = async (mealId: string, currentStatus: string) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    try {
      const {
        error
      } = await supabase.from('meals').update({
        status: newStatus
      }).eq('id', mealId);
      if (error) throw error;
      toast({
        title: "Status updated",
        description: `Meal status has been set to ${newStatus}`
      });
    } catch (error) {
      console.error('Error updating meal status:', error);
      toast({
        title: "Error",
        description: "Failed to update meal status",
        variant: "destructive"
      });
    }
  };
  return <AdminLayout title="Meals">
      <div className="space-y-4">
        {isLoading ? <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div> : meals?.map(meal => <Card key={meal.id} className="p-4">
              <div className="flex items-center gap-4">
                {meal.image && <img src={meal.image} alt={meal.name} className="w-20 h-20 rounded-lg object-cover" />}
                <div className="flex-1">
                  <h3 className="font-medium text-sm">{meal.name}</h3>
                  <p className="text-muted-foreground text-xs">
                    by {meal.profiles?.first_name} {meal.profiles?.last_name}
                  </p>
                  <p className="text-xs">
                    ${meal.price.toFixed(2)}
                  </p>
                </div>
                <Button variant={meal.status === 'active' ? 'destructive' : 'default'} onClick={() => handleStatusToggle(meal.id, meal.status)}>
                  {meal.status === 'active' ? 'Deactivate' : 'Activate'}
                </Button>
              </div>
            </Card>)}
      </div>
    </AdminLayout>;
};